import { mapMutations } from 'vuex';
import { TIER } from '@/constants/price';

export default {
  methods: {
    ...mapMutations({
      openFreeToProPopup: 'openFreeToProPopup',
      openProToPremiumPopup: 'openProToPremiumPopup',
    }),
    openUpgradePopup(tierKeyToUpgrade) {
      switch (tierKeyToUpgrade) {
        case TIER.PRO:
          this.openFreeToProPopup();
          break;
        case TIER.PREMIUM:
          this.openProToPremiumPopup();
          break;
        default:
          // TODO: log error
      }
    },
  },
};
